import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    tooltip: {
      padding: theme.spacing(0),
      backgroundColor: 'unset',
    },
    fullImageHover: {
      backgroundColor: COLORS.neutral.white,
      boxShadow: theme.shape.boxShadowMedium,
      border: theme.shape.borderGray70,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(1.5),
    },
    imageLabel: {
      display: 'inline',
      paddingTop: theme.spacing(1),
      wordWrap: 'break-word',
      textDecoration: 'underline',
      textAlign: 'left',
      color: COLORS.gray.black,
      maxWidth: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      ...theme.typography.regular12,
    },
  }),
  { name: 'ResourceThumbnailTooltip' }
);
